'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp, _dec2, _class3, _class4, _temp2, _dec3, _class5, _class6, _temp3;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _reactSelect = require('react-select');

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _reactRadioGroup = require('react-radio-group');

var _reactFlexboxGrid = require('react-flexbox-grid');

var _reactTooltip = require('react-tooltip');

var _reactTooltip2 = _interopRequireDefault(_reactTooltip);

var _reactSlidedown = require('react-slidedown');

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _format = require('../../helpers/format');

var _format2 = _interopRequireDefault(_format);

var _components = require('../../components');

var _IyvListFilters = require('./IyvListFilters.css');

var _IyvListFilters2 = _interopRequireDefault(_IyvListFilters);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IyvListGroupControl = (_dec = (0, _reactCssModules2.default)(_IyvListFilters2.default, { allowMultiple: true }), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(IyvListGroupControl, _Component);

  //
  function IyvListGroupControl(props) {
    (0, _classCallCheck3.default)(this, IyvListGroupControl);

    var _this = (0, _possibleConstructorReturn3.default)(this, (IyvListGroupControl.__proto__ || (0, _getPrototypeOf2.default)(IyvListGroupControl)).call(this, props));

    var params = [['All funds', 'rank'], ['By group', 'group'], ['By category', 'peer']];
    var tooltipText = '\n      Change the grouping used in the gender equality ranking. You can\n      group funds in three ways. The letter grade is always based on\n      the default setting, Groups.\n      <ul style="padding-inline-start: 10px;">\n        <li>\n          <i>All funds,</i> ranking all mutual funds and ETFs* against\n          each other\n        </li>\n        <li>\n          <i>By group,</i> the default setting, ranking funds against other\n          funds in the same Group of Morningstar Categories.\n        </li>\n        <li>\n          <i>By category,</i> ranking funds against other funds in\n          the same Morningstar Category\n        </li>\n      </ul>\n      *The research universe is approximately 4,900 open end mutual\n      funds and exchange traded funds domiciled in the U.S. with at\n      least 40% of holdings in stocks.\n    ';
    _this.state = {
      params: params,
      tooltipHtml: _format2.default.tooltipHtml(tooltipText)
    };
    return _this;
  }
  //


  (0, _createClass3.default)(IyvListGroupControl, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        'div',
        { styleName: 'active-group-control-wrap' },
        _react2.default.createElement(
          'div',
          {
            styleName: 'active-group-control-lbl',
            'data-multiline': true,
            'data-effect': 'solid',
            'data-tip': this.state.tooltipHtml,
            'data-for': 'group-control-lbl',
            'data-place': 'bottom',
            'data-html': true
          },
          _react2.default.createElement(
            'strong',
            null,
            'Gender equality ranking'
          ),
          _react2.default.createElement(_components.LinkIcon, { faclass: 'fa-info-circle' })
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'active-group-control-opt-wrp' },
          this.state.params.map(function (el, ix) {
            return _react2.default.createElement(
              'div',
              {
                key: 'grping_' + ix,
                styleName: _this2.props.activeGrouping !== el[1] ? 'active-group-control-opt' : 'active-group-control-opt-actv',
                onClick: function onClick() {
                  _this2.props.changeActiveGrouping(el[1]);
                }
              },
              _react2.default.createElement(
                'span',
                {
                  styleName: _this2.props.activeGrouping !== el[1] ? 'crt-inv' : 'crt-vis'
                },
                _react2.default.createElement(_components.LinkIcon, { faclass: 'fa-caret-right' })
              ),
              '\xA0',
              el[0]
            );
          })
        ),
        _react2.default.createElement(_reactTooltip2.default, { id: 'group-control-lbl' })
      );
    }
  }]);
  return IyvListGroupControl;
}(_react.Component), _class2.propTypes = {
  activeGrouping: _react.PropTypes.string,
  changeActiveGrouping: _react.PropTypes.func
}, _temp)) || _class);
var IyvListSelect = (_dec2 = (0, _reactCssModules2.default)(_IyvListFilters2.default, { allowMultiple: true }), _dec2(_class3 = (_temp2 = _class4 = function (_Component2) {
  (0, _inherits3.default)(IyvListSelect, _Component2);

  //
  function IyvListSelect(props) {
    (0, _classCallCheck3.default)(this, IyvListSelect);
    return (0, _possibleConstructorReturn3.default)(this, (IyvListSelect.__proto__ || (0, _getPrototypeOf2.default)(IyvListSelect)).call(this, props));
  }
  //


  (0, _createClass3.default)(IyvListSelect, [{
    key: 'render',
    value: function render() {
      var value = this.props.selectedFilters[this.props.name] || this.props.defaultFilter;
      var options = this.props.filterOptions(this.props.name);

      var asRadio = options.length <= 3 && name !== 'fffGrade' && name !== 'ffbGrade' && name !== 'ffiGrade' && name !== 'dffGrade' && name !== 'gefGrade' && name !== 'wffGrade' && name !== 'gffGrade' && name !== 'pffGrade' && name !== 'tffGrade';
      //
      return _react2.default.createElement(
        'div',
        {
          key: 'iyv-list-select-' + this.props.idx,
          styleName: 'filter'
        },
        _react2.default.createElement(
          'div',
          { styleName: 'filter-label' },
          this.props.label
        ),
        /* if it's a radio, a <RadioGroup> */
        asRadio ? _react2.default.createElement(
          _reactRadioGroup.RadioGroup,
          {
            name: this.props.name,
            Component: 'form',
            selectedValue: value,
            onChange: this.props.selectFilter(this.props.name)
          },
          /* for each option in this radio group, a <Radio/> */
          options.map(function (option) {
            return _react2.default.createElement(
              'label',
              {
                key: option.label,
                styleName: 'filter-radio-label'
              },
              _react2.default.createElement(_reactRadioGroup.Radio, { value: option.value }),
              '\xA0',
              option.label
            );
          })
        ) : null,
        /* if it's not a radio, a <Select/> */
        !asRadio ? _react2.default.createElement(_reactSelect2.default, {
          name: 'form-field-name',
          value: value,
          options: options,
          onChange: this.props.selectFilter(this.props.name)
        }) : null
      );
    }
  }]);
  return IyvListSelect;
}(_react.Component), _class4.propTypes = {
  selectedFilters: _react.PropTypes.object,
  filterOptions: _react.PropTypes.func,
  selectFilter: _react.PropTypes.func,
  idx: _react.PropTypes.number,
  label: _react.PropTypes.string,
  name: _react.PropTypes.string,
  defaultFilter: _react.PropTypes.string
}, _temp2)) || _class3);
var IyvListFilters = (_dec3 = (0, _reactCssModules2.default)(_IyvListFilters2.default, { allowMultiple: true }), _dec3(_class5 = (_temp3 = _class6 = function (_Component3) {
  (0, _inherits3.default)(IyvListFilters, _Component3);

  //
  function IyvListFilters(props) {
    (0, _classCallCheck3.default)(this, IyvListFilters);
    return (0, _possibleConstructorReturn3.default)(this, (IyvListFilters.__proto__ || (0, _getPrototypeOf2.default)(IyvListFilters)).call(this, props));
  }
  //


  (0, _createClass3.default)(IyvListFilters, [{
    key: 'render',
    value: function render() {
      var _this5 = this;

      var renderFiltersCol = function renderFiltersCol(order) {
        return _react2.default.createElement(
          _reactFlexboxGrid.Col,
          { xs: 12, sm: 6 },
          /* Filters are a global at top of file */
          _this5.props.filters.filter(function (filter) {
            // order === 0 means left column of filters
            // order === 1 means left column of filters
            return filter.order === order;
          }).map(function (filter, idx) {
            return _react2.default.createElement(IyvListSelect, {
              selectedFilters: _this5.props.selectedFilters,
              filterOptions: _this5.props.filterOptions,
              selectFilter: _this5.props.selectFilter,
              idx: idx,
              label: filter.label,
              name: filter.state,
              defaultFilter: _this5.props.defaultFilter
            });
          })
        );
      };
      return _react2.default.createElement(
        'div',
        {
          styleName: this.props.currentTutorial === 2 && this.props.showTutorial ? 'tutorial-highlight-filters-wrap' : null,
          onClick: this.props.clickCloseTutorial
        },
        _react2.default.createElement(
          _reactSlidedown.SlideDown,
          null,
          /* show the slide down panel of filters or don't */
          this.props.showFilters ? _react2.default.createElement(
            'div',
            { styleName: 'filters' },
            _react2.default.createElement(
              'div',
              { styleName: 'filters-info' },
              'Filter your search results\xA0',
              _react2.default.createElement('span', {
                'data-multiline': true,
                'data-effect': 'solid',
                'data-tip': _format2.default.tooltipHtml('Use the settings to control your search ' + 'results. Hide and show funds by grade, asset ' + 'manager, fund category, and more.'),
                'data-place': 'bottom',
                'data-for': 'filters-tooltip',
                'data-html': true,
                className: 'fa fa-info-circle'
              })
            ),
            _react2.default.createElement(_reactTooltip2.default, { id: 'filters-tooltip' }),
            _react2.default.createElement(
              _reactFlexboxGrid.Row,
              null,
              renderFiltersCol(0),
              renderFiltersCol(1)
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'filters-info-2' },
              'Filter by issue'
            ),
            _react2.default.createElement(
              _reactFlexboxGrid.Row,
              null,
              renderFiltersCol(2),
              renderFiltersCol(3)
            ),
            /* if GEF, show group controls for ranking */
            _config2.default.app.title === 'Gender Equality Funds' ? _react2.default.createElement(
              _reactFlexboxGrid.Row,
              null,
              _react2.default.createElement(IyvListGroupControl, {
                activeGrouping: this.props.activeGrouping,
                changeActiveGrouping: this.props.changeActiveGrouping
              })
            ) : null
          ) : null
        )
      );
    }
  }]);
  return IyvListFilters;
}(_react.Component), _class6.propTypes = {
  activeGrouping: _react.PropTypes.string,
  showFilters: _react.PropTypes.bool,
  currentTutorial: _react.PropTypes.number,
  showTutorial: _react.PropTypes.bool,
  clickCloseTutorial: _react.PropTypes.func,
  changeActiveGrouping: _react.PropTypes.func,
  selectFilter: _react.PropTypes.func,
  filterOptions: _react.PropTypes.func,
  selectedFilters: _react.PropTypes.object,
  filters: _react.PropTypes.array,
  defaultFilter: _react.PropTypes.string
}, _temp3)) || _class5);
exports.default = IyvListFilters;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/core/IyvListFilters/IyvListFilters.js
// module id = 1366
// module chunks = 0